// src/components/icons/SwiperArrowLeft.jsx
import React from 'react';

const SwiperArrowLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="white"/>
    <path d="M14 6L8 12L14 18" stroke="#B3B3B3" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default SwiperArrowLeft;